import React, {useState} from 'react';

// Aws Data Store and Model
import { DataStore } from 'aws-amplify';
import { Form } from '../models';

import BreadcrumbsComponent from "../components/layout/BreadcrumbsComponent";
import Wrapper from "../components/layout/Wrapper";
import { useParams } from 'react-router';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ApplicationListItem from '../components/ApplicationListItem';
import ModalComponent from '../components/ModalComponent';
import ApplicationForm from '../forms/ApplicationForm';
import FormsForm from '../forms/FormsForm';

export default function Formen({user, signOut}) {

  const {id} = useParams();

  // Fetch Products
  const [forms, setForms] = useState([]);
	React.useEffect(() => {
		fetchForms();
		async function fetchForms() {
			try {
        const forms = await DataStore.query(Form);
        setForms(forms);
      } catch (error) {
        console.log("Error retrieving Applications", error);
      }
		}
      DataStore.observe(Form).subscribe(() => {
        fetchForms();
      }
    );
	}, []);  


  return (
    <Wrapper user={user} signOut={signOut}>
      <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', height:'80px'}}>
        <BreadcrumbsComponent />
        <ModalComponent
          buttonContent="neue Formen hinzufügen"
          modalHeadline=""
        >
          <FormsForm />
        </ModalComponent>
      </div>
      <TableContainer style={{marginTop:'40px'}}>
        <Table sx={{ minWidth: 650 }} aria-label="caption table">
          <TableHead style={{backgroundColor:'#E30015'}}>
            <TableRow >
              <TableCell style={{color:'#fff', fontWeight:'700'}}>Formen</TableCell>
              <TableCell align="right" style={{color:'#fff', fontWeight:'700'}}></TableCell>
              <TableCell align="right" style={{color:'#fff', fontWeight:'700'}}></TableCell>
              <TableCell align="right" style={{color:'#fff', fontWeight:'700'}}></TableCell>
              <TableCell align="right" style={{color:'#fff', fontWeight:'700'}}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {forms.map((form) => (
              <ApplicationListItem 
                name={form.name}
                key={form.id}
                passedId={form.id}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Wrapper>
  );
}